import { useMyUser } from '@consigli/hooks';
import { useEffect, type FC } from 'react';

import { identify } from './instance';

/**
 * Tells the flag client who is signed in, which starts it. Must sit below
 * `UserGuard`: `useMyUser` throws on a null user.
 */
export const FeatureFlagIdentity: FC = () => {
  const { user } = useMyUser();

  useEffect(() => {
    identify(user.id);
  }, [user.id]);

  return null;
};
